// initial state
const state = {
	viewportSize: {
		width: window.innerWidth,
		height: window.innerHeight
	},
	scrollPosition: {
		x: 0,
		y: 0
	},
	mousePosition: {
		x: window.innerWidth / 2,
		y: window.innerHeight / 2
	},
	deviceOrientation: {
		alpha: 0,
		beta: 0,
		gamma: 0
	},
	loaderIsHidden: false,
    contentLoaded: false,
    sliderCanSwitch: false,
	blockedOverflow: true,
	mobile: false,
	cursor: 'default'
}

// getters
const getters = {
	viewportSize: state => state.viewportSize,
	scrollPosition: state => state.scrollPosition,
	mousePosition: state => state.mousePosition,
	deviceOrientation: state => state.deviceOrientation,
	isContentLoaded: state => state.contentLoaded,
	loaderIsHidden: state => state.loaderIsHidden,
    sliderCanSwitch: state => state.sliderCanSwitch,
	blockedOverflow: state => state.blockedOverflow,
	isMobile: state => state.mobile,
	cursor: state => state.cursor
}

// actions
const actions = {
	updateViewportSize({ commit }, size) {
		commit('UPDATE_VIEWPORT_SIZE', size)
	},
	updateScrollPosition({ commit }, position) {
		commit('UPDATE_SCROLL_POSITION', position)
	},
	updateMousePosition({ commit }, position) {
		commit('UPDATE_MOUSE_POSITION', position)
	},
	updateDeviceOrientation({ commit }, orientation) {
		commit('UPDATE_DEVICE_ORIENTATION', orientation)
	},
	contentIsLoaded({ commit }) {
		commit('CONTENT_LOADED')
	},
	loaderIsHidden({ commit }) {
		commit('LOADER_IS_HIDDEN')
	},
    sliderCanSwitch({ commit }, canSwitch) {
        commit('SLIDER_CAN_SWITCH', canSwitch)
    },
    blockOverflow({ commit }) {
        commit('UPDATE_BLOCKED_OVERFLOW', true)
    },
    unblockOverflow({ commit }) {
        commit('UPDATE_BLOCKED_OVERFLOW', false)
	},
	setMobile({ commit }) {
		commit('SET_MOBILE')
	},
	updateCursor({ commit }, cursor) {
		commit('UPDATE_CURSOR', cursor)
	}
}

// mutations
const mutations = {
	UPDATE_VIEWPORT_SIZE(state, size) {
		state.viewportSize = size
	},
	UPDATE_SCROLL_POSITION(state, position) {
		state.scrollPosition = position
	},
	UPDATE_MOUSE_POSITION(state, position) {
		state.mousePosition = position
	},
	UPDATE_DEVICE_ORIENTATION(state, orientation) {
		state.deviceOrientation = orientation
	},
	CONTENT_LOADED(state) {
		state.contentLoaded = true
	},
    LOADER_IS_HIDDEN(state) {
		state.loaderIsHidden = true
	},
    SLIDER_CAN_SWITCH(state, canSwitch) {
        state.sliderCanSwitch = canSwitch
    },
    UPDATE_BLOCKED_OVERFLOW(state, blocked) {
        state.blockedOverflow = blocked
	},
	SET_MOBILE(state) {
		state.mobile = true
	},
	UPDATE_CURSOR(state, cursor) {
		state.cursor = cursor
	}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ui.js